module.exports = __webpack_public_path__ + "img/HA1503-02.ce34e11a.jpg";